var MASTER = {
    FormatDate: function(date, format) {
        date = new Date(date);
        let day, month, year, output;
        if (format === "Slash") {
            year = date.getFullYear();
            month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : "0" + month;
            day = date.getDate().toString();
            day = day.length > 1 ? day : "0" + day;
            output = month + "/" + day + "/" + year.toString().substr(-2);
        }
        if (format === "Full") {
            month = date.toLocaleString("default", { month: "long" });
            day = date.getDate();
            year = date.getFullYear();
            if (month.length < 2) {
                month = "0" + month;
            }
            if (day.length < 2) {
                day = "0" + day;
            }
            output = month + " " + day + ", " + year;
        }
        return output;
    },
    CollectFormData: function(form) {
        return JSON.parse('{"' + decodeURIComponent(form.serialize()).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    },
    Bind: function(key, Action) {
        document.addEventListener("keydown", function(event) {
            if (event.key === key) {
                Action();
            }
        });
    },
    PromptLeavingPage: function (url) {
        if (confirm("You are now leaving the Los Angeles County Registrar-Recorder/County Clerk website and linking to a website that may contain commercial advertising. The County of Los Angeles does not endorse or support any of the advertising that may be contained on this site. Do you wish to continue?")) {
            window.open(url);
        }
        return false;
    }
};

module.exports = { MASTER };